import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    const text = this.element.dataset.text || this.element.textContent;
    if (!text) {
      console.warn("No text associated with this clipboard");
      return;
    }

    const icon = document.createElement("i");
    icon.className = `fa-solid fa-circle-check`;
    let iconActive = false;

    this.boundClick = (e) => {
      navigator.clipboard.writeText(text);
      e.preventDefault();

      if (!iconActive) {
        iconActive = true;
        let original = this.element.innerHTML;
        this.element.appendChild(icon);
        this.iconTimeout = setTimeout(() => {
          this.element.innerHTML = original;
          iconActive = false;
        }, 1000);
      }
    };
    this.element.addEventListener("click", this.boundClick);
  }

  disconnect() {
    this.element.removeEventListener("click", this.boundClick);
    if (this.iconTimeout) {
      clearTimeout(this.iconTimeout);
    }
  }
}
